/**
 * Trust Logos Section - Dark blue background with centered label
 */

import osutoriLogo from "@/assets/logos/osutori-white.png";
import onvajouerLogo from "@/assets/logos/onvajouer-white.png";
import hybforceLogo from "@/assets/logos/hybforce-white.png";
import shayLogo from "@/assets/logos/shay-white.png";
import goapLogo from "@/assets/logos/goap-white.png";
import forevadifferentLogo from "@/assets/logos/forevadifferent-white.png";
import wensjegelukLogo from "@/assets/logos/wensjegeluk-white.png";
import laLuunLogo from "@/assets/logos/la-luun-baby-logo-white.png";
import diamondLogo from "@/assets/logos/diamond-detailing-white.png";
import candiezLogo from "@/assets/logos/candiez-white.png";

const logos = [
  { src: hybforceLogo, alt: "Hybforce", desktopClass: "h-9", mobileClass: "h-7" },
  { src: onvajouerLogo, alt: "ONVAJOUER", desktopClass: "h-7", mobileClass: "h-5" },
  { src: forevadifferentLogo, alt: "ForevaDifferent" },
  { src: shayLogo, alt: "Shay", desktopClass: "h-8", mobileClass: "h-6" },
  { src: goapLogo, alt: "GOAP", desktopClass: "h-7", mobileClass: "h-5" },
  { src: osutoriLogo, alt: "Osutori", desktopClass: "h-7", mobileClass: "h-5" },
  { src: diamondLogo, alt: "Diamond Detailing", desktopClass: "h-9", mobileClass: "h-7" },
  { src: candiezLogo, alt: "Candiez" },
  { src: wensjegelukLogo, alt: "Wens je Geluk" },
  { src: laLuunLogo, alt: "La Luun Baby" },
];


export default function TrustLogosSection() {
  return (
    <>
      {/* Desktop Logo Section */}
      <section className="hidden md:block px-4 md:px-12 pt-3 pb-8 bg-primary overflow-hidden">
        <div className="max-w-[1400px] mx-auto">
          <p className="text-white/60 text-sm text-center mb-3">Samen met deze 30+ webshops</p>

          <div className="relative overflow-hidden">
            <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-primary to-transparent z-10 pointer-events-none" />
            <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-primary to-transparent z-10 pointer-events-none" />

            <div className="flex animate-marquee-desktop">
              <div className="flex items-center gap-16 pr-16 shrink-0">
                {logos.map((logo, i) => (
                  <div key={`desk-set1-${i}`} className="h-12 flex items-center justify-center shrink-0">
                    <img src={logo.src} alt={logo.alt} className={`${logo.desktopClass ?? "h-10"} w-auto object-contain opacity-80`} />
                  </div>
                ))}
              </div>
              <div className="flex items-center gap-16 pr-16 shrink-0" aria-hidden="true">
                {logos.map((logo, i) => (
                  <div key={`desk-set2-${i}`} className="h-12 flex items-center justify-center shrink-0">
                    <img src={logo.src} alt={logo.alt} className={`${logo.desktopClass ?? "h-10"} w-auto object-contain opacity-80`} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mobile Logo Slider */}
      <section className="md:hidden px-0 pt-2 pb-6 bg-primary overflow-hidden">
        <p className="text-white/60 text-sm text-center mb-2 px-4">Samen met deze 30+ webshops</p>

        <div className="relative overflow-hidden">
          <div className="absolute left-0 top-0 bottom-0 w-10 bg-gradient-to-r from-primary to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-10 bg-gradient-to-l from-primary to-transparent z-10 pointer-events-none" />

          <div className="flex marquee-mobile-track" style={{ minWidth: '200%' }}>
            {[0, 1].map((setIndex) => (
              <div key={`mob-set-${setIndex}`} className="flex items-center gap-8 pr-8 shrink-0" aria-hidden={setIndex === 1}>
                {logos.map((logo, i) => (
                  <div key={`mob-${setIndex}-${i}`} className="h-10 flex items-center justify-center shrink-0">
                    <img src={logo.src} alt={setIndex === 0 ? logo.alt : ""} className={`${logo.mobileClass ?? "h-8"} w-auto object-contain opacity-80`} loading="eager" />
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
